import * as tsx from 'vue-tsx-support';

import { injectStylesMixin } from '@jtnews/shared';

import styles from './record-attentions.style.scss?module';

const BAA_IMAGE_URL = 'https://static.ngs.ru/info/ne-lekarstvo-2.png';
const CONTRAINDICATIONS_IMAGE_URL = 'https://static.ngs.ru/info/disclaimer.png';

export default tsx.componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'RecordAttentions',
  props: {
    isBaa: {
      type: Boolean,
      default: false
    },
    isContraindications: {
      type: Boolean,
      default: false
    }
  },
  render() {
    return (
      <div class={styles.attention}>
        {this.isBaa ? (
          <img class={styles.attentionImage} src={BAA_IMAGE_URL} alt="" />
        ) : null}
        {this.isContraindications ? (
          <img class={styles.attentionImage} src={CONTRAINDICATIONS_IMAGE_URL} alt="" />
        ) : null}
      </div>
    );
  }
});
